import { Box, Typography } from "@material-ui/core";
import { AccessTime } from "@material-ui/icons";
import React from "react";
import { useEffect, useState } from "react"


export const DigitalClock = () => {

    const [time, setTime] = useState(new Date());

    useEffect(() => {
        const timer = setInterval(() => {
            setTime(new Date());
        }, 1000);
        return () => clearInterval(timer);
    }, []);
    const date = time.toLocaleDateString("ar-SA", {
        timeZone: "Asia/Riyadh",
        weekday: "long",
        year: "numeric",
        month: "2-digit",
        day: "numeric",
        calendar: "gregory",
    });
    const times = time.toLocaleTimeString("en-GB", {
        timeZone: "Asia/Riyadh",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
        hour12: false,
    });


    return (
        <Box
            style={{
                display: "flex",
                alignItems: "center",
                gap: 8,
                direction: "ltr",
                padding: "8px 14px",
                borderRadius: 8,
                background: "#f3f5f7",

            }}
        >
            <Typography
                style={{
                    fontSize: 15,
                    fontWeight: "bold",
                    fontFamily: "monospace",
                    letterSpacing: 1,
                    direction: "rtl"
                }}
            >
                <div>{date}</div>
                <div>{times}</div>
            </Typography>
            <AccessTime />

        </Box>
    )
}